import React, { useState, useEffect } from 'react';

const VendorNotifications = ({ user }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        // Mock vendor notifications data
        const mockNotifications = [
          {
            id: 1,
            client: 'Sam & Taylor',
            subject: 'Menu Confirmation',
            message: 'Sam has requested changes to the menu selection.',
            time: '1h',
            unread: true,
            icon: 'utensils'
          },
          {
            id: 2,
            client: 'Riley & Alex',
            subject: 'Payment Received',
            message: 'Final payment has been processed successfully.',
            time: '3h',
            unread: false,
            icon: 'dollar-sign'
          }
        ];
        setNotifications(mockNotifications);
      } catch (error) {
        console.error('Error loading notifications:', error);
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    loadNotifications();
  }, [user]);

  if (loading) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        Loading notifications...
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <div className="page-header" style={{
        backgroundColor: '#E8F4E8',
        padding: '48px 24px',
        textAlign: 'center'
      }}>
        <h1 className="page-title" style={{ 
          fontSize: '56px', 
          fontWeight: '400', 
          color: '#1F2937',
          margin: 0,
          fontFamily: 'Georgia, serif',
          letterSpacing: '-0.02em'
        }}>
          Notifications
        </h1>
      </div>

      {/* Notifications List */}
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px 24px 24px' }}>
        {notifications.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '48px 24px',
            color: '#6B7280'
          }}>
            No notifications yet
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {notifications.map((notification) => (
            <div
              key={notification.id}
              style={{
                padding: '20px',
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                display: 'flex',
                alignItems: 'center',
                gap: '16px'
              }}
            >
              <div style={{
                width: '48px',
                height: '48px',
                backgroundColor: '#E8F4E8',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {notification.icon === 'utensils' && (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6B9080" strokeWidth="1.5">
                    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/>
                    <path d="M7 2v20"/>
                    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>
                  </svg>
                )}
                {notification.icon === 'dollar-sign' && (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6B9080" strokeWidth="1.5">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '18px', fontWeight: '500', color: '#1F2937', marginBottom: '4px' }}>
                  {notification.client} - {notification.subject}
                </div>
                <div style={{ fontSize: '14px', color: '#6B7280' }}>
                  {notification.message}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ fontSize: '14px', color: '#6B7280' }}>
                  {notification.time}
                </div>
                {notification.unread && (
                  <div style={{ width: '8px', height: '8px', backgroundColor: '#EF4444', borderRadius: '50%' }}></div>
                )}
              </div>
            </div>
          ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorNotifications;